import { createWebHistory, createRouter } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'IntroView',
    component: () => import(/* webpackChunkName: "intro" */ '@/views/IntroView.vue')
  },
  {
    path: '/home',
    name: 'HomeView',
    component: () => import(/* webpackChunkName: "home" */ '@/views/HomeView.vue')
  },
  {
    path: '/project',
    name: 'ProjectView',
    component: () => import(/* webpackChunkName: "project" */ '@/views/ProjectView.vue')
  },
  {
    path: '/learning/easymake',
    name: 'EasyMake',
    component: () => import(/* webpackChunkName: "learning" */ '@/views/learning/EasyMake.vue')
  },
  {
    path: '/learning/hotkeys',
    name: 'HotKeys',
    component: () => import(/* webpackChunkName: "learning" */ '@/views/learning/hotKeys.vue')
  },
  {
    path: '/skill/skillclip',
    name: 'SkillClip',
    component: () => import(/* webpackChunkName: "skill" */ '@/views/skill/skillClip.vue')
  },
  {
    path: '/skill/skillkeyframe',
    name: 'SkillKeyframe',
    component: () => import(/* webpackChunkName: "skill" */ '@/views/skill/skillKeyframe.vue')
  },
  {
    path: '/skill/skillmotion',
    name: 'SkillMotion',
    component: () => import(/* webpackChunkName: "skill" */ '@/views/skill/skillMotion.vue')
  },
  {
    path: '/skill/skillframe',
    name: 'skillFrame',
    component: () => import(/* webpackChunkName: "skill" */ '@/views/skill/skillFrame.vue')
  },
  {
    path: '/skill/skilltrim',
    name: 'SkillTrim',
    component: () => import(/* webpackChunkName: "skill" */ '@/views/skill/skillTrim.vue')
  },
  {
    path: '/skill/skillmarker',
    name: 'SkillMarker',
    component: () => import(/* webpackChunkName: "skill" */ '@/views/skill/skillMarker.vue')
  },
  {
    path: '/toppannel',
    name: 'TopPannel',
    component: () => import(/* webpackChunkName: "toppannel" */ '@/views/topPannel.vue')
  },
  {
    path: '/effect/cliptab',
    name: 'ClipTab',
    component: () => import(/* webpackChunkName: "effect" */ '@/views/effect/clipTab.vue')
  },
  {
    path: '/effect/texttab',
    name: 'TextTab',
    component: () => import(/* webpackChunkName: "effect" */ '@/views/effect/textTab.vue')
  },
  {
    path: '/effect/objecttab',
    name: 'ObjectTab',
    component: () => import(/* webpackChunkName: "effect" */ '@/views/effect/objectTab.vue')
  },
  {
    path: '/effect/effectstab',
    name: 'EffectsTab',
    component: () => import(/* webpackChunkName: "effect" */ '@/views/effect/effectsTab.vue')
  },
  {
    path: '/effect/overlaytab',
    name: 'OverlayTab',
    component: () => import(/* webpackChunkName: "effect" */ '@/views/effect/overlayTab.vue')
  },
  {
    path: '/effect/cliptransition',
    name: 'ClipTransition',
    component: () => import(/* webpackChunkName: "effect" */ '@/views/effect/clipTransition.vue')
  },
  {
    path: '/effect/tracktransition',
    name: 'TrackTransition',
    component: () => import(/* webpackChunkName: "effect" */ '@/views/effect/trackTransition.vue')
  },
  {
    path: '/previewpannel',
    name: 'PreviewPannel',
    component: () => import(/* webpackChunkName: "preview" */ '@/views/previewPannel.vue')
  },
  {
    path: '/timeline/default',
    name: 'TimelineDefault',
    component: () => import(/* webpackChunkName: "timeline" */ '@/views/timeline/TimelineDefault.vue')
  },
  {
    path: '/timeline/controlarea',
    name: 'ControlArea',
    component: () => import(/* webpackChunkName: "timeline" */ '@/views/timeline/ControlArea.vue')
  },
  {
    path: '/timeline/workspace',
    name: 'TimeWorkspace',
    component: () => import(/* webpackChunkName: "timeline" */ '@/views/timeline/TimeWorkspace.vue')
  },
  {
    path: '/setup/setting',
    name: 'SettingView',
    component: () => import(/* webpackChunkName: "setup" */ '@/views/setup/settingView.vue')
  },
  {
    path: '/setup/projectsetting',
    name: 'ProjectSetting',
    component: () => import(/* webpackChunkName: "setup" */ '@/views/setup/projectSetting.vue')
  },
  {
    path: '/send/export',
    name: 'ExportView',
    component: () => import(/* webpackChunkName: "send" */ '@/views/send/exportView.vue')
  },
  {
    path: '/send/advanced',
    name: 'AdvancedView',
    component: () => import(/* webpackChunkName: "send" */ '@/views/send/advancedView.vue')
  },
  {
    path: '/license',
    name: 'LicenseView',
    component: () => import(/* webpackChunkName: "license" */ '@/views/licenseView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(), // 해시모드 제거
  routes,
  scrollBehavior () {
    return { top: 0 }
  }
})

export default router
